'use client'

/**
 * Purpose: Survey wrinkled/tight axis page — slider when self-knowledge is yes, else questionnaire.
 * Inputs: formState, updateSection, setSlider, and tPages translator.
 * Outputs: SkinAxisSlider or SectionPage with WRINKLED_QUESTIONS.
 */

import type { FormState } from '@lib/models/types'
import { WRINKLED_QUESTIONS } from '@lib/survey-questions'
import { SectionPage } from '@components/pages/SectionPage/SectionPage'
import { SkinAxisSlider } from '@components/sliders/SkinAxisSlider/SkinAxisSlider'

export function SurveyWrinkledPage({
  formState,
  updateSection,
  setSlider,
  tPages,
}: {
  formState: FormState
  updateSection: (
    section: 'wrinkledAnswers',
    key: string,
    value: string,
  ) => void
  setSlider: (axis: 'wrinkled', value: number) => void
  // updateSection writes one questionnaire answer key at a time.
  tPages: (key: string) => string
}) {
  // "I know my skin" → single slider; otherwise full question set.
  if (formState.skinKnowledge.wrinkled) {
    return (
      <div id="survey-wrinkled-page">
        {/* Self-reported axis value — skips the multi-question branch. */}
        <SkinAxisSlider
          value={formState.sliderValues.wrinkled}
          onChange={(v) => setSlider('wrinkled', v)}
          title={tPages('wrinkledSlider.title')}
          description={tPages('wrinkledSlider.description')}
          leftLabel={tPages('wrinkledSlider.leftLabel')}
          rightLabel={tPages('wrinkledSlider.rightLabel')}
        />
      </div>
    )
  }

  // Detailed questionnaire when user does not self-report axis knowledge.
  return (
    <div id="survey-wrinkled-page">
      <SectionPage
        sectionKey="wrinkledTight"
        questions={WRINKLED_QUESTIONS}
        answers={formState.wrinkledAnswers}
        onAnswer={(k, v) => updateSection('wrinkledAnswers', k, v)}
      />
    </div>
  )
}
